import MyFavoritesToggle from './MyFavoritesToggle.vue'

export default MyFavoritesToggle
